import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=231bae4c&scoped=true"
import script from "./GeneralForm.vue?vue&type=script&lang=ts"
export * from "./GeneralForm.vue?vue&type=script&lang=ts"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=231bae4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bae4c",
  null
  
)

export default component.exports